var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 26,
    fill: "none",
    viewBox: "0 0 24 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/about_big"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.861 12.572v.37m0 0H4.7c-1.647 0-2.95 1.313-2.95 2.893 0 1.58 1.303 2.892 2.95 2.892h.196c.36 3.106 3.423 5.773 7.09 5.773 3.668 0 6.73-2.667 7.091-5.773h.223c1.647 0 2.95-1.313 2.95-2.892 0-1.58-1.303-2.893-2.95-2.893h-.188m-14.251 0v5.785m14.251-5.785v-2.899m0 2.9v5.784m-4.017 1.31c-.43 1.248-1.739 2.102-3.222 2.102-.907 0-1.74-.317-2.353-.844m1.642-4.204c-.456.589-.145 1.718.711 1.911m-1.166-4.66c0-1.85-2.406-1.85-2.406 0a1.208 1.208 0 0 0 2.405 0Zm4.878 0c0-1.85-2.405-1.85-2.405 0 0 1.77 2.405 1.77 2.405 0Zm3.562-11.835-3.661 2.68L10.29 1.6 6.64 6.728 2.276 5.446l2.78 7.543 14.091-2.454V2.507Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutBig);
export default __webpack_public_path__ + "static/media/about_big.3409ce4db428145bee48ea2e732fc151.svg";
export { ForwardRef as ReactComponent };